export const FETCH_INVOICE_REQUEST = 'FETCH_INVOICE_REQUEST';
export const FETCH_INVOICE_SUCCESS = 'FETCH_INVOICE_SUCCESS';
export const FETCH_INVOICE_FAILURE = 'FETCH_INVOICE_FAILURE';
